<nav class="bg-white">
  <div class="w-full pr-2 sm:pr-4 lg:pr-6 pl-0 max-w-4xl mx-auto">
    <div class="flex items-center min-h-20 py-3">
      <!-- Main Menu Button - Far left -->
      <button
        type="button"
        id="mobile-menu-button"
        *ngIf="!isMobileMenuOpen"
        class="inline-flex items-center justify-center p-2 text-gray-700 hover:text-gray-900 focus:outline-none mt-2 md:mt-0 flex-shrink-0"
        style="
          margin-left: 0;
          padding-left: 8px;
          width: 48px;
          z-index: 10000;
          position: relative;
          pointer-events: auto !important;
          cursor: pointer;
        "
        (click)="toggleMobileMenu($event)"
        (touchstart)="toggleMobileMenu($event)"
      >
        <!-- Hamburger icon - always shown -->
        <svg
          class="block h-6 w-6"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 6h16M4 12h16M4 18h16"
          />
        </svg>
      </button>

      <!-- App Title/Logo - Centered relative to content area below (matching max-w-4xl container) -->
      <div
        *ngIf="!isMobileMenuOpen"
        class="flex items-center flex-1"
        style="justify-content: center; margin-left: -48px"
      >
        <img
          [src]="logoUrl"
          alt="TilHub Logo"
          style="
            display: inline-block;
            vertical-align: middle;
            margin-right: 8px;
            margin-top: 10px;
            width: 50px;
            height: 50px;
            object-fit: contain;
            max-width: 50px;
            max-height: 50px;
          "
        />
        <h1
          class="text-xl font-bold text-gray-900 inline-block"
          style="vertical-align: middle"
        >
          {{ translations.translation }}
        </h1>
      </div>

      <!-- Desktop Navigation Menu - Removed as requested -->
      <div class="hidden">
        <!-- Menu removed -->
      </div>
    </div>

    <!-- Mobile Navigation Menu - Slide from left like Charles Schwab -->
    <div
      *ngIf="isMobileMenuOpen"
      class="menu-overlay-blocker"
      (click)="closeMobileMenu()"
    >
      <!-- Slide-out menu from left -->
      <div
        class="absolute top-0 left-0 bg-white shadow-xl slide-menu"
        style="
          width: min(90vw, 350px);
          max-width: 350px;
          height: 100vh;
          overflow-y: auto;
          overflow-x: hidden;
        "
        (click)="$event.stopPropagation()"
      >
        <!-- Menu Header with User Info -->
        <div class="bg-gray-50 p-4 border-b border-gray-200">
          <div class="flex items-center justify-between mb-2">
            <div>
              <h2 class="text-lg font-semibold text-gray-900">
                {{ translations.hello }}, {{ currentUser?.name || "User" }}
              </h2>
              <p class="text-sm text-gray-600" *ngIf="currentUser?.email">
                {{ currentUser?.email }}
              </p>
            </div>
            <button
              (click)="closeMobileMenu()"
              class="p-2 rounded-md hover:bg-gray-200"
            >
              <svg
                class="h-5 w-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
          <button
            *ngIf="isLoggedIn"
            (click)="onLogout(); closeMobileMenu()"
            class="text-sm text-blue-600 hover:text-blue-800 font-medium px-3 py-2 rounded-md border border-blue-200 bg-blue-50 hover:bg-blue-100 transition-colors duration-200"
          >
            {{ translations.logout }}
          </button>
        </div>

        <!-- Menu Items -->
        <div class="py-2">
          <!-- Global Advanced Translation Model -->
          <div class="px-3 py-2">
            <div class="advanced-model-menu-row">
              <input
                type="checkbox"
                class="advanced-model-menu-checkbox"
                [checked]="globalAdvancedModelEnabled"
                (change)="onGlobalAdvancedModelChange($any($event.target).checked)"
              />
              <span class="advanced-model-menu-title">
                {{ translations.advancedModel || "Advanced translation model" }}
              </span>
              <button
                type="button"
                class="advanced-model-info-icon"
                (click)="showGlobalAdvancedModelInfo($event)"
                (touchstart)="showGlobalAdvancedModelInfo($event)"
                [attr.aria-label]="translations.advancedModelDescription || 'Advanced translation model information'"
              >
                !
              </button>
            </div>
          </div>

          <!-- Live Translation (gpt-realtime-translate), admin only -->
          <div class="px-3 py-2" *ngIf="isAdmin()">
            <div class="advanced-model-menu-row">
              <input
                type="checkbox"
                class="advanced-model-menu-checkbox"
                [checked]="liveTranslationEnabled"
                (change)="onLiveTranslationChange($any($event.target).checked)"
              />
              <span class="advanced-model-menu-title">
                {{ translations.liveTranslation || "Live translation" }}
              </span>
              <button
                type="button"
                class="advanced-model-info-icon"
                (click)="showLiveTranslationInfo($event)"
                (touchstart)="showLiveTranslationInfo($event)"
                [attr.aria-label]="translations.liveTranslationDescription || 'Live translation information'"
              >
                !
              </button>
            </div>
          </div>

          <!-- Speed Control Mobile -->
          <div class="px-3 py-2">
            <div class="pt-3 border-t border-gray-200">
              <label class="block text-sm font-medium text-gray-700 mb-2">
                {{ translations.speakingSpeed }}
              </label>
              <div class="flex items-center gap-2">
                <span class="text-sm text-gray-500 flex-shrink-0 text-xs">{{
                  translations.slow
                }}</span>
                <input
                  type="range"
                  [(ngModel)]="speakingSpeed"
                  (ngModelChange)="onSpeedChange()"
                  min="0.5"
                  max="1.5"
                  step="0.1"
                  class="flex-1 h-2 rounded-lg appearance-none cursor-pointer slider mx-2"
                  style="background: #d1d5db"
                />
                <span
                  class="text-sm text-gray-500 flex-shrink-0 text-xs mr-2"
                  >{{ translations.fast }}</span
                >
                <span
                  class="text-sm font-medium text-blue-600 min-w-[5rem] text-center flex-shrink-0 bg-blue-50 px-3 py-1 rounded-md border border-blue-200"
                >
                  {{ (speakingSpeed * 100).toFixed(0) }}%
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Voice Selection Mobile -->
        <div class="px-3 py-2">
          <div class="text-sm text-gray-500 mb-2">
            {{ translations.voiceType }}:
          </div>
          <div class="grid grid-cols-2 gap-4">
            <button
              *ngFor="let voice of availableVoices"
              (click)="selectVoice(voice.id); closeMobileMenu()"
              [class]="
                selectedVoice === voice.id
                  ? 'bg-blue-600 text-white'
                  : 'text-gray-700 hover:bg-gray-100'
              "
              class="text-left px-2 py-2 text-sm rounded-md transition-colors duration-200 flex flex-col items-center gap-1 min-w-0 w-full"
            >
              <span class="text-lg flex-shrink-0">{{ voice.icon }}</span>
              <span class="text-xs text-center leading-tight break-words">{{
                voice.name
              }}</span>
            </button>
          </div>
        </div>

        <!-- Speaker Separation is now always enabled for better detection -->
        <!-- Removed Multi-Speaker Mode toggle - diarization is always ON -->

        <!-- Language Selection Mobile -->
        <div class="px-3 py-2">
          <div class="text-sm text-gray-500 mb-2">
            {{ translations.languages }}:
          </div>
          <div class="space-y-3">
            <!-- User Language Selection -->
            <div>
              <label class="block text-xs text-gray-600 mb-1">
                {{ translations.yourLanguage }}
              </label>
              <select
                [(ngModel)]="selectedUserLanguage"
                (ngModelChange)="onUserLanguageChange()"
                class="w-full px-3 py-2 text-sm font-medium border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent language-select"
              >
                <option *ngFor="let lang of userLanguages" [value]="lang.value">
                  {{ lang.label }}
                </option>
              </select>
            </div>

            <!-- Partner Language Selection -->
            <div>
              <label class="block text-xs text-gray-600 mb-1">
                {{ translations.partnerLanguage }}
              </label>
              <select
                [(ngModel)]="selectedPartnerLanguage"
                (ngModelChange)="onPartnerLanguageChange()"
                class="w-full px-3 py-2 text-sm font-medium border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent language-select"
              >
                <option
                  *ngFor="let lang of getFilteredPartnerLanguages()"
                  [value]="lang.value"
                >
                  {{ lang.label }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <!-- Main Menu Items -->
        <div class="mt-4">
          <button
            *ngIf="isLoggedIn"
            (click)="onShowHistory(); closeMobileMenu()"
            class="w-full text-left px-4 py-3 text-gray-900 hover:bg-gray-100 flex items-center gap-3"
          >
            <svg
              class="h-6 w-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
              />
            </svg>
            <span class="font-medium">{{
              translations.history || "Message Center"
            }}</span>
          </button>

          <button
            *ngIf="isLoggedIn"
            (click)="onShowWordUsage(); closeMobileMenu()"
            class="w-full text-left px-4 py-3 text-gray-900 hover:bg-gray-100 flex items-center gap-3"
          >
            <svg
              class="h-6 w-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
              />
            </svg>
            <span class="font-medium">{{ translations.wordUsage }}</span>
          </button>

          <button
            *ngIf="isLoggedIn"
            (click)="onShowImageUsage(); closeMobileMenu()"
            class="w-full text-left px-4 py-3 text-gray-900 hover:bg-gray-100 flex items-center gap-3"
          >
            <svg
              class="h-6 w-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
            <span class="font-medium">{{ translations.imageUsage }}</span>
          </button>

          <!-- Analytics Button (Admin Only) -->
          <button
            *ngIf="isLoggedIn && canViewAnalytics()"
            (click)="onShowAnalytics(); closeMobileMenu()"
            class="w-full text-left px-4 py-3 text-gray-900 hover:bg-gray-100 flex items-center gap-3"
          >
            <svg
              class="h-6 w-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
            <span class="font-medium">{{ translations.analytics }}</span>
          </button>

          <!-- Language Settings Button -->
          <button
            (click)="onShowLanguageSettings()"
            class="w-full text-left px-4 py-3 text-gray-900 hover:bg-gray-100 flex items-center gap-3"
          >
            <svg
              class="h-6 w-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9-3-9m-9 9a9 9 0 019-9"
              />
            </svg>
            <span class="font-medium">{{ translations.languageSettings }}</span>
          </button>
        </div>

        <!-- Buy Words Button -->
        <div class="mb-3">
          <button
            *ngIf="isLoggedIn && !isIOS()"
            (click)="onShowBuyWords(); closeMobileMenu()"
            class="w-full flex items-center gap-3 px-4 py-3 text-gray-700 hover:bg-blue-50 hover:text-blue-700 rounded-lg transition-colors duration-200"
          >
            <svg
              class="w-5 h-5 text-blue-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1"
              />
            </svg>
            <span class="font-medium">{{ getBuyWordsButtonLabel() }}</span>
          </button>
        </div>

        <!-- Support Link -->
        <div class="mb-3">
          <button
            (click)="openSupport(); closeMobileMenu()"
            class="w-full text-left px-4 py-3 text-gray-900 hover:bg-gray-100 flex items-center gap-3"
          >
            <svg
              class="h-6 w-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z"
              />
            </svg>
            <span class="font-medium">{{ translations.support || 'Support' }}</span>
          </button>
        </div>

        <!-- Divider -->
        <div class="border-t border-gray-200 my-4"></div>

        <!-- Show Login/Register when not logged in -->
        <div *ngIf="!isLoggedIn">
          <button
            class="w-full text-left px-4 py-3 text-gray-900 hover:bg-gray-100 flex items-center gap-3"
          >
            <svg
              class="h-6 w-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
              />
            </svg>
            <span class="font-medium">{{ translations.login }}</span>
          </button>
          <button
            class="w-full text-left px-4 py-3 text-gray-900 hover:bg-gray-100 flex items-center gap-3"
          >
            <svg
              class="h-6 w-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
              />
            </svg>
            <span class="font-medium">{{ translations.register }}</span>
          </button>
        </div>

        <!-- Version Info at bottom -->
        <div class="px-4 py-4 border-t border-gray-200 mt-4">
          <div class="text-xs text-gray-500 flex items-center justify-between">
            <span>Version {{ getVersionDisplay() }}</span>
            <span
              [class]="
                isNewVersion ? 'text-green-600 font-semibold' : 'text-gray-400'
              "
            >
              {{ getVersionStatus() }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</nav>
